import DefaultLayout from '##/Default';
import ViewOrders from './List';
import AmenityConfigForm from './AmenityConfigForm';
import _AmenityReport from './_AmenityReport';
import AmenityReport from './AmenityReport';


const routes = [
    {
        path: '/properties/:property_id/orders',
        exact: true,
        layout: DefaultLayout,
        component: ViewOrders,
        auth: true,
        title: 'Orders'
    },
    {
        path: '/properties/:property_id/amenity-config',
        exact: true,
        layout: DefaultLayout,
        component: AmenityConfigForm,
        auth: true,
        title: 'Amenity Config Form'
    },
    {
        path: '/properties/:property_id/_amenity-report',
        exact: true,
        layout: DefaultLayout,
        component: _AmenityReport,
        auth: true,
        title: '_Amenity Report'
    },
    {
        path: '/properties/:property_id/amenity-report',
        exact: true,
        layout: DefaultLayout,
        component: AmenityReport,
        auth: true,
        title: 'Amenity Report'
    }


];

export default routes;
